export const gyanMetrics = [
  {
    label: "SCALE",
    value: "40K+",
    title: "Registered Users",
    desc: "Solo prototype → production scale",
  },
  {
    label: "CODEBASE",
    value: "344K+ LOC",
    title: "Platform Shipped",
    desc: "Admin CRM · Web · Mobile",
  },
  {
    label: "DATABASE",
    value: "88 / 175",
    title: "PostgreSQL Core",
    desc: "Tables · Stored Procedures (RPCs)",
  },
  {
    label: "CONCURRENCY",
    value: "2.1M+",
    title: "Campaigns Dispatched",
    desc: "Relay Race queue · zero double-sends",
  },
  {
    label: "CONVERSION",
    value: "1% ➔ 6.2%",
    title: "Paid Conversion",
    desc: "Lead 360 scoring 0–100 · 6x lift",
  },
  {
    label: "AUTOMATION",
    value: "75% Faster",
    title: "Content Turnaround",
    desc: "Gemini AST JSON · 110K+ records",
  },
];

export const gyanStack = [
  "TypeScript (Strict)",
  "React 19 · TanStack Start",
  "React Native Expo · Tauri 2",
  "PostgreSQL 88 Tables · 175 RPCs",
  "Supabase Edge Functions",
  "Yjs + Lexical",
  "Tailwind v4",
  "Gemini API · Node.js",
];

export const gyanClients = [
  {
    kicker: "Mobile Runtime",
    title: "Mobile Apps (Android & iOS)",
    desc: "React Native (Expo) + TanStack Router. Low-latency clients with background sync, virtualized lists (@tanstack/react-virtual), and frictionless onboarding.",
    links: [
      { label: "Android — Play Store", href: "https://play.google.com/store/apps/details?id=com.divas_regmi.loksewaapp" },
      { label: "iOS — App Store", href: "https://apps.apple.com/vn/app/loksewa-by-gyanudaan/id6769264147" },
    ],
    anchor: { label: "View 20 Mobile Screens", href: "#gyanudaan-mobile" },
  },
  {
    kicker: "Desktop App",
    title: "Desktop Client (Tauri 2)",
    desc: "Tauri 2 desktop app for long study sessions. Distraction-free full-screen mock exams, keyboard shortcuts, and Yjs + Lexical collaborative editing.",
    links: [{ label: "Desktop Platform", href: "https://gyanudaan.com/desktop" }],
    anchor: { label: "Inspect Admin Consoles", href: "#gyanudaan-admin" },
  },
  {
    kicker: "Web Runtime",
    title: "Web Ecosystem (TanStack Start)",
    desc: "React 19 + TanStack Start web hub. SEO-optimized notices, syllabus updates, and Tailwind v4 design system.",
    links: [{ label: "Visit Web Portal", href: "https://gyanudaan.com/" }],
    anchor: { label: "Explore Lead 360 CRM Suite", href: "#gyanudaan-crm" },
  },
];

export const gyanCrmFeatures = [
  {
    index: "01",
    tag: "ALGORITHMIC SCORING",
    title: "Behavioral Lead Scoring 0–100",
    desc: "Algorithmic scoring of engagement, quiz behavior, and intent signals. Powers prioritization for telesales and automated audience segments.",
  },
  {
    index: "02",
    tag: "VOICE INTELLIGENCE",
    title: "Telesales + Sentiment Analysis",
    desc: "Call logging with sentiment analysis. Telesales teams work from scored queues, not spreadsheets.",
  },
  {
    index: "03",
    tag: "NO-CODE BUILDER",
    title: "Visual SQL Audience Builder",
    desc: "Non-technical team builds SQL audiences visually — pushing targeted campaigns without engineering bottlenecks.",
  },
  {
    index: "04",
    tag: "ZERO-TRUST SECURITY",
    title: "RBAC + PostgreSQL RLS",
    desc: "Dynamic, metadata-driven Role-Based Access Control enforced via RLS. Granular team control for creators/typists, sensitive payment data restricted.",
  },
  {
    index: "05",
    tag: "SUB-SECOND LATENCY",
    title: "High-Performance UI",
    desc: "Virtualized data grids (@tanstack/react-virtual) and Yjs + Lexical collaborative rich-text for sub-second interactions at scale.",
  },
  {
    index: "06",
    tag: "FINANCIAL INTEGRITY",
    title: "Financial Ledger & Verification",
    desc: "Multi-gateway ledger with manual bank receipt verification workflows, real-time revenue ledgers, and QR/digital wallet reconciliation.",
  },
];

export const gyanPipeline = [
  {
    step: "01. INGEST",
    title: "New Data Detection",
    desc: "Messy 200-page PDFs → structured ingestion queue",
  },
  {
    step: "02. GENERATE",
    title: "Gemini API",
    desc: "Auto-generation, tagging, AST JSON mapping",
  },
  {
    step: "03. AUDIT",
    title: "Stale Data Flagging",
    desc: "Flags outdated answers across 110K+ records",
  },
  {
    step: "04. HUMAN REVIEW",
    title: "1-Click Publish",
    desc: "Editor approves in admin panel (Yjs+Lexical)",
  },
  {
    step: "05. PUBLISH & DISPATCH",
    title: "40K+ Users",
    desc: "Realtime sync + 2.1M campaigns via Relay Race queue (atomic batch-locking, zero double-sends)",
  },
];

export const gyanEvolution = [
  {
    dimension: "Team & Role",
    before: "1 solo developer",
    after: "Founding Engineer & Technical Lead · Core platform delivered · Available full-time",
  },
  {
    dimension: "Platform",
    before: "Monolithic prototype",
    after: "SaaS & CRM (Lead 360) — 344k+ LOC · React 19 · TanStack Start · Tauri 2",
  },
  {
    dimension: "Database",
    before: "Ad-hoc schema",
    after: "PostgreSQL — 88 tables, 175 RPCs, Closure Tables O(1), ACID, ledger",
  },
  {
    dimension: "Content",
    before: "Manual copy-pasting",
    after: "Gemini AST JSON · 110K+ records · 75% faster · human-in-loop",
  },
  {
    dimension: "Delivery & UI",
    before: "Basic screens",
    after: "2.1M campaigns (Relay Race) · virtualized grids · Yjs+Lexical · RLS RBAC",
  },
  {
    dimension: "Scale & Revenue",
    before: "100 early testers",
    after: "40,000+ registered users · 6.2% conversion (Lead 360 0–100)",
  },
];

export const gyanMobileImages = Array.from({ length: 20 }, (_, i) => {
  const n = String(i + 1).padStart(2, "0");
  return {
    src: `/images/gyanudaan/mobile/mobile-${n}.webp`,
    alt: `GyanUdaan mobile screen ${i + 1}`,
    label: `UI SCREEN ${n}`,
  };
});

export const gyanAdminImages = Array.from({ length: 12 }, (_, i) => {
  const n = String(i + 1).padStart(2, "0");
  return {
    src: `/images/gyanudaan/admin/admin-${n}.webp`,
    alt: `GyanUdaan admin console ${i + 1}`,
    label: `ADMIN VIEW ${n}`,
    url: `admin.gyanudaan.com/console/${n}`,
  };
});
